/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type CreateChatCompletionRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  openAIChatCompletionRequestParams:
    components.OpenAIChatCompletionRequestParams;
};

export type CreateChatCompletionResponse =
  | components.OpenAIChatCompletion
  | string;

/** @internal */
export const CreateChatCompletionRequest$inboundSchema: z.ZodType<
  CreateChatCompletionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  OpenAIChatCompletionRequestParams:
    components.OpenAIChatCompletionRequestParams$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "OpenAIChatCompletionRequestParams": "openAIChatCompletionRequestParams",
  });
});
/** @internal */
export type CreateChatCompletionRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  OpenAIChatCompletionRequestParams:
    components.OpenAIChatCompletionRequestParams$Outbound;
};

/** @internal */
export const CreateChatCompletionRequest$outboundSchema: z.ZodType<
  CreateChatCompletionRequest$Outbound,
  z.ZodTypeDef,
  CreateChatCompletionRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  openAIChatCompletionRequestParams:
    components.OpenAIChatCompletionRequestParams$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    openAIChatCompletionRequestParams: "OpenAIChatCompletionRequestParams",
  });
});

export function createChatCompletionRequestToJSON(
  createChatCompletionRequest: CreateChatCompletionRequest,
): string {
  return JSON.stringify(
    CreateChatCompletionRequest$outboundSchema.parse(
      createChatCompletionRequest,
    ),
  );
}
export function createChatCompletionRequestFromJSON(
  jsonString: string,
): SafeParseResult<CreateChatCompletionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateChatCompletionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateChatCompletionRequest' from JSON`,
  );
}

/** @internal */
export const CreateChatCompletionResponse$inboundSchema: z.ZodType<
  CreateChatCompletionResponse,
  z.ZodTypeDef,
  unknown
> = z.union([components.OpenAIChatCompletion$inboundSchema, z.string()]);
/** @internal */
export type CreateChatCompletionResponse$Outbound =
  | components.OpenAIChatCompletion$Outbound
  | string;

/** @internal */
export const CreateChatCompletionResponse$outboundSchema: z.ZodType<
  CreateChatCompletionResponse$Outbound,
  z.ZodTypeDef,
  CreateChatCompletionResponse
> = z.union([components.OpenAIChatCompletion$outboundSchema, z.string()]);

export function createChatCompletionResponseToJSON(
  createChatCompletionResponse: CreateChatCompletionResponse,
): string {
  return JSON.stringify(
    CreateChatCompletionResponse$outboundSchema.parse(
      createChatCompletionResponse,
    ),
  );
}
export function createChatCompletionResponseFromJSON(
  jsonString: string,
): SafeParseResult<CreateChatCompletionResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CreateChatCompletionResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateChatCompletionResponse' from JSON`,
  );
}
